import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { getPolyglot } from '../../../i18n';

import { reportSchedulesMock } from '../../../redux/reports/api/reports.mock';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ReportSchedule } from '../../../redux/reports/api/Report.model';
import { useNavigate } from 'react-router-dom';
import ReportAPI from '../../../redux/reports/api/ReportAPI';
import { useAppSelector } from '../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../redux/stoerkID/selectors/StoerkId.selectors';
interface ReportScheduleListProps {
  groupId?: string;
}
const ReportScheduleList = (props: ReportScheduleListProps) => {
  const { groupId } = props;
  const navigate = useNavigate();

  const polyglot = getPolyglot();
  const rows = reportSchedulesMock;
  const workspaceId = useAppSelector(getMyWorkspaceSelector)?.id;
  const { data: reportSchedules, isLoading } =
    ReportAPI.endpoints.getReportSchedules.useQuery({
      groupId,
      workspaceId: workspaceId ?? '',
    });
  const columns: GridColDef<ReportSchedule>[] = [
    {
      field: 'id',
      headerName: 'ID',
      valueGetter: (params) => params.row.id,
      sortable: true,
    },
    {
      field: 'reportSpec.reportTitle',
      headerName: polyglot.t('reports.table.title') || 'Title',
      valueGetter: (params) => params.row.reportSpec.reportTitle,
      flex: 1,
      minWidth: 180,
      sortable: true,
    },
    {
      field: 'reportType',
      headerName: polyglot.t('reports.table.type') || 'Type',
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => params.row.reportSpec.reportType?.name,
      sortable: true,
    },
    {
      field: 'interval',
      headerName: polyglot.t('reports.table.interval') || 'Interval',
      valueGetter: (params) => {
        const { intervalType, intervalValue } = params.row || {};
        return intervalType && intervalValue
          ? `${intervalValue} ${intervalType}`
          : '';
      },

      minWidth: 180,
      sortable: false,
    },
  ];

  return (
    <>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 },
          },
          sorting: { sortModel: [{ field: 'timestampStart', sort: 'desc' }] },
        }}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50, 100, 200, 500, 1000]}
      />
    </>
  );
};

export default ReportScheduleList;
